import { useQuery } from "@tanstack/react-query";
import {
  RelatedCompanyDto,
  UserProfileDto,
  UserRole,
} from "@green0meter/api-client";

import { DOMAIN_COMPANIES } from "../domain";

import { companiesApi } from "@api/services";
import { TANSTACK_QUERY_STALE_TIME } from "@constants";
import { roleGuard } from "@api";

export const ACTION_GET_MASTER_RELATED_COMPANIES = "GET_MASTER_RELATED_COMPANIES";

const allowedRoles = [UserRole.Owner, UserRole.Manager];

const getGetMasterRelatedCompanies = async (): Promise<RelatedCompanyDto[]> => {
  const response =
    await companiesApi.companiesControllerGetAllMasterRelatedCompanies();

  return response.data;
};

export const useGetMasterRelatedCompanies = (
  user: UserProfileDto | null,
): {
  masterRelatedCompanies?: RelatedCompanyDto[];
  masterRelatedCompaniesEnabled: boolean;
  isLoadingGetMasterRelatedCompanies: boolean;
  isSuccessGetMasterRelatedCompanies: boolean;
} => {
  const enabled = roleGuard(user, allowedRoles);
  const { data, isLoading, isSuccess } = useQuery({
    queryKey: [DOMAIN_COMPANIES, ACTION_GET_MASTER_RELATED_COMPANIES],
    queryFn: () => getGetMasterRelatedCompanies(),
    staleTime: TANSTACK_QUERY_STALE_TIME,
  });

  return {
    masterRelatedCompanies: data,
    masterRelatedCompaniesEnabled: enabled,
    isLoadingGetMasterRelatedCompanies: isLoading,
    isSuccessGetMasterRelatedCompanies: isSuccess,
  };
};
